import { ArrowRight, Download, Building2, Rocket, Check } from "lucide-react";
import { Reveal, scrollToSection } from "./shared";
import { paths, profile } from "../../data/portfolioData";

const PathCard = ({ data, icon: Icon, accent, testId }) => {
  const amber = accent === "amber";
  const ring = amber ? "hover:border-amber-400/25" : "hover:border-emerald-400/25";
  const iconColor = amber ? "text-amber-400" : "text-emerald-400";
  const bullet = amber ? "bg-amber-400" : "bg-emerald-400";
  const btnCls = amber
    ? "bg-amber-400 text-[#07090E] hover:bg-amber-300 hover:shadow-[0_0_30px_-8px_rgba(245,158,11,0.7)]"
    : "bg-emerald-400 text-[#07090E] hover:bg-emerald-300 hover:shadow-[0_0_30px_-8px_rgba(16,185,129,0.6)]";

  const Primary = data.primary.kind === "resume" ? (
    <a
      href={profile.resumeUrl}
      download
      className={`inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300 ${btnCls}`}
      data-testid={`${testId}-primary`}
    >
      <Download size={15} /> {data.primary.label}
    </a>
  ) : (
    <button
      onClick={() => scrollToSection(data.primary.target)}
      className={`group inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300 ${btnCls}`}
      data-testid={`${testId}-primary`}
    >
      {data.primary.label}
      <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
    </button>
  );

  return (
    <div
      className={`h-full rounded-3xl border border-white/[0.07] bg-[#0F1420] p-7 sm:p-9 transition-all duration-500 ${ring}`}
      data-testid={testId}
    >
      <div className={`inline-flex rounded-xl border border-white/[0.08] bg-white/[0.04] p-3 ${iconColor}`}>
        <Icon size={22} strokeWidth={1.8} />
      </div>
      <p className={`mt-5 font-code text-[11px] uppercase tracking-[0.25em] ${amber ? "text-amber-400/90" : "text-emerald-400/90"}`}>
        {data.eyebrow}
      </p>
      <h3 className="mt-2 font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-50">{data.title}</h3>
      <ul className="mt-6 space-y-3">
        {data.points.map((p) => (
          <li key={p} className="flex gap-2.5 text-sm text-slate-300 leading-relaxed">
            <Check size={15} className={`mt-0.5 shrink-0 ${amber ? "text-amber-400" : "text-emerald-400"}`} />
            {p}
          </li>
        ))}
      </ul>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        {Primary}
        <button
          onClick={() => scrollToSection(data.secondary.target)}
          className="rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-slate-300 transition-all duration-300 hover:border-white/35 hover:text-slate-100"
          data-testid={`${testId}-secondary`}
        >
          {data.secondary.label}
        </button>
      </div>
    </div>
  );
};

export const WorkPaths = () => (
  <section className="py-14 lg:py-20" data-testid="work-paths-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-center font-code text-xs sm:text-sm tracking-[0.25em] uppercase text-slate-500 mb-10">
          Two ways we can work together
        </p>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-5 lg:gap-7">
        <Reveal>
          <PathCard data={paths.recruiter} icon={Building2} accent="emerald" testId="path-recruiter" />
        </Reveal>
        <Reveal delay={0.12}>
          <PathCard data={paths.founder} icon={Rocket} accent="amber" testId="path-founder" />
        </Reveal>
      </div>
    </div>
  </section>
);
